export * from './HeatingIcon'
